<template>
  <v-container>
    <annual-review-user-list
      :user="profile"
      v-if="!is_admin && !profile.isManager"
    ></annual-review-user-list>
    <loading-spinner v-else-if="loading"></loading-spinner>
    <template v-else>
      <v-row v-if="profile.directManagerId != null">
        <v-col
          cols="12"
          v-if="selfReview != null && !selfReview.userQuestionsComplete"
        >
          <single-list-item
            color="performance"
            button-text="Your Review Page"
            label="Reminder"
            v-on:click="router.push({ path: `/annual-reviews/${profile.id}` })"
          >
            You have a self review to complete for your manager,
            {{ profile.directManagerName }}
          </single-list-item>
        </v-col>
      </v-row>
      <header-card
        icon="event"
        title="Review Management"
        sub-title="Get you and your team ready for their annual reviews"
      >
        <template v-slot:right>
          <engagement-text
            title="Participation Rate"
            :engagement="overview.userRecords"
            class="subtitle-1"
          ></engagement-text>
        </template>
        <template v-slot:extension v-if="is_admin || is_manager">
          <v-divider></v-divider>
          <v-row dense>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
              <v-btn
                text
                to="/reporting/annual-reviews"
                color="secondary"
                block
              >
                <v-icon class="mr-2">assessment</v-icon>
                Reporting
              </v-btn>
            </v-col>
            <template v-if="is_admin">
              <v-divider
                vertical
                v-if="$vuetify.breakpoint.mdAndUp"
              ></v-divider>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
                <v-btn
                  text
                  to="/features/annual-reviews/settings"
                  color="secondary"
                  block
                >
                  <v-icon class="mr-2">settings</v-icon>
                  Admin Settings
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </template>
      </header-card>
      <annual-review-manager-table
        v-if="profile.isManager"
        v-on:filter="filterId = $event"
      >
      </annual-review-manager-table>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AnnualReviewUserList from "@/components/annualreviews/AnnualReviewUserList";
import HeaderCard from "@/components/common/HeaderCard";
import AnnualReviewManagerTable from "@/components/annualreviews/AnnualReviewManagerTable";
import EngagementText from "@/components/reporting/EngagementText";
export default {
  name: "AnnualReviewOverview",
  components: {
    AnnualReviewManagerTable,
    AnnualReviewUserList,
    HeaderCard,
    EngagementText
  },
  data: () => ({
    loading: false,
    hideTable: false,
    filterId: null
  }),
  watch: {
    profile(val, oldVal) {
      if (val == oldVal) {
        return;
      }
      this.getData();
    }
  },
  computed: {
    totalReviews() {
      return this.list.filter(x => x.annualReviewStartDate == this.filterId)
        .length;
    },
    completeReviews() {
      return this.list.filter(
        x => x.complete && x.annualReviewStartDate == this.filterId
      ).length;
    },
    list() {
      return this.annual_reviews;
    },
    selfReview() {
      return this.annual_reviews.find(
        x => x.user.id == this.profile.id && !x.complete
      );
    },
    ...mapGetters({
      annual_reviews: "annualreview/list",
      overview: "annualreview/overview",
      profile: "profile/profile",
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager"
    })
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this._.isEmpty(this.profile) || !this.profile.isManager) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("annualreview/getAnnualReviewOverview")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your annual reviews."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
